var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcUndo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_undo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_undo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-General-/-Share",
    fill: "#133a7b",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.11111111,21 L14.7777778,21 C18.766501,21 22,17.7269192 22,13.6893695 C22,9.65181979 18.766501,6.37873904 14.7777778,6.37873904 L6.9,6.37873904 L8.34444444,4.92786007 C8.78013574,4.4868354 8.78013573,3.77179315 8.34444443,3.3307685 C7.90875313,2.88974384 7.20235797,2.88974383 6.76666667,3.33076848 L3.43333333,6.70490563 C3.22298594,6.91608905 3.10466853,7.20356088 3.10466853,7.50345142 C3.10466853,7.80334196 3.22298594,8.09081379 3.43333333,8.30199721 L6.76666667,11.6761344 C7.20751142,12.0582855 7.86466019,12.032592 8.27507025,11.6171581 C8.6854803,11.2017241 8.71086311,10.5365311 8.33333333,10.0902899 L6.9,8.6281638 L14.7777778,8.6281638 C17.5392015,8.6281638 19.7777778,10.8941428 19.7777778,13.6893695 C19.7777778,16.4845963 17.5392015,18.7505752 14.7777778,18.7505752 L3.11111111,18.7505752 C2.49746139,18.7505752 2,19.2541261 2,19.8752876 C2,20.4964491 2.49746139,21 3.11111111,21 Z",
    id: "Path"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUndo);
export default __webpack_public_path__ + "static/media/ic_undo.f4f64244df6d4511fc2be991c43f32e0.svg";
export { ForwardRef as ReactComponent };